import { PureComponent, type ReactElement, type ReactNode } from 'react';

import type { MenuItemEvent } from '../../../components/context_menu/types';
import SelectableItems from '../../../components/selectable_items/selectable_items';
import type { MenuItem } from '../../../ui/menus/menu/types';
import TableView from '../../../ui/table/table';
import type { Column } from '../../../ui/table/types';
import { ui } from '../../../utils/helpers';
import AclsListContextMenu from '../context_menu';
import type { AclsContextItem } from '../types';

import styles from './acls_table.module.css';

type Props<T> = {
  columns: Column<T>[];
  title: string | ReactElement;
  items: T[];
  contextMenu?: typeof AclsListContextMenu;
  onContextMenuItemClicked?: (menuItem: MenuItem, event: MenuItemEvent) => void;
};

type State = {
  selectedIds: string[];
};

class AclsTable<T extends AclsContextItem> extends PureComponent<
  Props<T>,
  State
> {
  state = {
    selectedIds: [],
  };

  setSelectedRows = (ids: string[]): void => {
    this.setState({
      selectedIds: ids,
    });
  };

  render(): ReactNode {
    const { items, title, columns, contextMenu } = this.props;
    const { selectedIds } = this.state;

    if (!items.length) {
      return null;
    }

    return (
      <>
        <div {...ui('title')}>{title}</div>
        <SelectableItems
          contextMenu={contextMenu ?? AclsListContextMenu}
          onContextMenuItemClicked={this.props.onContextMenuItemClicked}
          onSelectIds={this.setSelectedRows}
          items={items}
          multiselect={false}
        >
          <TableView
            className={styles.table}
            cellClassName={styles.td}
            items={items}
            selectedIds={selectedIds}
            renderColumns={columns}
            showHeader={false}
          />
        </SelectableItems>
      </>
    );
  }
}

export default AclsTable;
